import { render, staticRenderFns } from "./AlarmChannel.vue?vue&type=template&id=5a4718eb"
import script from "./AlarmChannel.vue?vue&type=script&lang=js"
export * from "./AlarmChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports